import React, { useEffect, useReducer, useState } from "react";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import {
  Autocomplete,
  Box,
  Card,
  CardHeader,
  Chip,
  IconButton,
  Stack,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialDataGrid from "../../../../components/MaterialDataGrid";
import PageLoading from "../../../../components/Loading/PageLoading";

import { useLoading } from "../../../../context/LodingContext";
import request from "graphql-request";
import BASEURL from "../../../../pages/Utils/Baseurl";
import { downloadExcelFile } from "../../../function/downloadExcel";
import {
  allUsers,
  allProducts,
  StockExpiryReport,
  ExportStockExpiryReport,
} from "../ReportData";
import MaterialBox from "../../../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import {
  Tooltip,
  Legend,
  ResponsiveContainer,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Bar,
} from "recharts";
import OptionConvert from "../../../components/OptionConvert";
import {
  realtimeInventoryState,
  RealtimeInventoryStateMange,
} from "../ReportStateMange";
import RefreshIcon from "@mui/icons-material/Refresh";
import Swal from "sweetalert2";
import URL from "../../../../pages/Utils/url";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ReusableFilter from "../../../components/ReusableFilter";
import FilterListIcon from "@mui/icons-material/FilterList";
import { getallmall } from "../../productDisplayCompliance/api/query";
import ReportDefaultUi from "../reportDefaultui";
import AppliedFilter from "../AppliedFilter/AppliedFilter";

function StockExpiry() {
  const { setCirleLoading } = useLoading();
  const [stockExpiryData, dispatch] = useReducer(
    RealtimeInventoryStateMange,
    realtimeInventoryState,
  );
  const [isTabel, setIsTabel] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [datas, setData] = useState([]);
  const [value, setValue] = useState(0);
  const [agentOptions, setAgentOptions] = useState([
    { label: "All", value: "All" },
  ]);
  const [marketOptions, setMarketOptions] = useState([
    { label: "All", value: "All" },
  ]);
  const [productOptions, setProductOptions] = useState([
    { label: "All", value: "All" },
  ]);

  const [dialogOpen, setDialogOpen] = useState(false);

  // Pagination state for graph view
  const [currentPage, setCurrentPage] = useState(0);
  const recordsPerPage = 5;

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        await Promise.all([fetchAgentName(), fetchProduct(), fetchmarket()]);
      } catch (error) {
        console.error("Error fetching data", error);
      }
    };

    fetchAllData();
    setIsTabel(false);
  }, []);

  const processedData = datas?.flatMap((entry) =>
    entry.agreedProducts.map((product) => ({
      productName: product.product?.productName || "Unknown Product",
      quantity: product.quantity || 0,
    })),
  );

  // Calculate pagination values
  const totalPages = Math.ceil(datas?.length / recordsPerPage);
  const currentData = processedData?.slice(
    currentPage * recordsPerPage,
    (currentPage + 1) * recordsPerPage,
  );

  // Pagination handlers
  const handleNext = () => {
    if (currentPage < totalPages - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Reset pagination when data changes
  const resetPagination = () => {
    setCurrentPage(0);
  };

  //reset filter data
  const resetFilters = () => {
    dispatch({ name: "reset" });
    setData([]);
    setIsTabel(false);
    setIsLoading(false);
    setCurrentPage(1);
  };

  //table row and colomn
  const stockExpiryListTable = {
    columns: [
      {
        headerName: "S.No",
        field: "sno",
        name: "S.NO",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Agent",
        field: "agent",
        name: "agent",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Contact Person",
        field: "contactPerson",
        name: "contactPerson",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Market Name",
        field: "marketName",
        name: "marketName",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Product",
        field: "productName",
        name: "productName",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "contractStart",
        field: "contractStart",
        name: "contractStart",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Contract End",
        field: "contractEnd",
        name: "contractEnd",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
    ],
    rows: datas.map((value, i) => ({
      id: value?.id,
      sno: i + 1,
      agent: value?.agent?.employeeName,
      contactPerson: value?.contactPerson,
      marketName: value?.marketName,
      contractEnd: value?.contractEnd,
      contractStart: value?.contractStart,
      productName: value?.agreedProducts[0]?.product?.productName,
    })),
  };

  //download file
  const handleDownload = (
    startDate,
    endDate,
    marketsName,
    agentsName,
    productName,
  ) => {
    const markets =
      marketsName?.length > 0 &&
      !marketsName.some((item) => item.label === "All")
        ? marketsName.map((item) => item.label) || []
        : [];

    const agents =
      agentsName?.length > 0 && !agentsName.some((item) => item.value === "All")
        ? agentsName.map((item) => item.value) || []
        : [];

    const product =
      productName?.length > 0 &&
      !productName.some((item) => item.value === "All")
        ? productName.map((item) => item.value) || []
        : [];

    setCirleLoading(true);
    request(BASEURL, ExportStockExpiryReport, {
      startDate: startDate,
      endDate: endDate,
      marketNames: markets,
      agentIds: agents,
      productIds: product,
    })
      .then(async (res) => {
        const status = res?.exportStockExpiryReport?.success;

        const pdfurl = `${URL}${res?.exportStockExpiryReport?.fileUrl?.slice(
          1,
        )}`;

        if (status) {
          const status = await downloadExcelFile(pdfurl, "stock_expiry.xlsx");
          setCirleLoading(false);
        }
      })
      .finally(() => {
        setCirleLoading(false);
      });
  };

  // get market option
  const fetchmarket = () => {
    request(BASEURL, getallmall)
      .then((res) => {
        const market = OptionConvert(
          res?.allMallEntriesList,
          "marketName",
          "id",
        );
        setMarketOptions((prevOptions) => [...prevOptions, ...market]);
      })
      .finally(() => {});
  };

  //get market option
  const fetchProduct = () => {
    request(BASEURL, allProducts)
      .then((res) => {
        const productName = res?.allProductsDropdown?.data.map((item) => ({
          id: item?.id,
          value: item?.productCode,
          label: item?.productName,
        }));
        setProductOptions((prevOptions) => [...prevOptions, ...productName]);
      })
      .finally(() => {});
  };

  //get agent name option
  const fetchAgentName = () => {
    request(BASEURL, allUsers)
      .then((res) => {
        const productName = OptionConvert(res?.allUsers, "employeeName", "id");
        setAgentOptions((prevOptions) => [...prevOptions, ...productName]);
      })
      .finally(() => {});
  };

  //filter api call
  const fetchFilteredStock = (
    startDate,
    endDate,
    agents,
    market,
    productName,
  ) => {
    setIsLoading(true);
    setIsTabel(true);

    const payload = {
      startDate: startDate,
      endDate: endDate,
      marketNames: market,
      agentIds: agents,
      productIds: productName,
    };

    request(BASEURL, StockExpiryReport, payload)
      .then((res) => {
        const newdata = res?.getStockExpiryReport?.data;
        setData(newdata);
        resetPagination();
      })
      .catch((err) => {
        const message =
          err?.response?.errors?.[0]?.message ||
          err?.message ||
          "Something went wrong";
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      })
      .finally(() => {
        setIsLoading(false);
        setIsTabel(true);
      });
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  //filter submit
  const submitFilter = (data) => {
    const agentName =
      stockExpiryData?.agentName?.length > 0 &&
      !stockExpiryData.agentName.some((item) => item.value === "All")
        ? stockExpiryData.agentName.map((item) => item.value)
        : [];

    const market =
      stockExpiryData?.market?.length > 0 &&
      !stockExpiryData.market.some((item) => item.label === "All")
        ? stockExpiryData.market.map((item) => item.label)
        : [];

    const productName =
      stockExpiryData?.productName?.length > 0 &&
      !stockExpiryData.productName.some((item) => item.value === "All")
        ? stockExpiryData.productName.map((item) => item.value)
        : [];

    fetchFilteredStock(
      stockExpiryData.fromDate,
      stockExpiryData.toDate,
      agentName,
      market,
      productName,
    );
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Stock Expiry List
                </MaterialTypography>
              </Stack>
              <Box sx={{ mx: "5%" }}>
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  {datas.length > 0 && (
                    <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
                      <Tabs
                        value={value}
                        onChange={handleChange}
                        TabIndicatorProps={{
                          style: {
                            backgroundColor: "#2a9941",
                            color: "white",
                          },
                        }}
                        sx={{ px: 2 }}
                        centered
                      >
                        <Tab sx={{ px: 2 }} label="Table list view" />
                        <Tab sx={{ px: 2 }} label="Graph view" />
                      </Tabs>
                    </Box>
                  )}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      bgcolor: "background.paper",
                    }}
                  >
                    <IconButton
                      onClick={() => setDialogOpen(true)}
                      aria-label="Filters"
                      color="primary"
                    >
                      <FilterListIcon fontSize="medium" />
                    </IconButton>
                    <IconButton
                      onClick={resetFilters}
                      aria-label="Reset Filters"
                      color="primary"
                    >
                      <RefreshIcon fontSize="medium" />
                    </IconButton>
                  </Box>
                </Stack>
              </Box>
              {stockExpiryData?.fromDate && stockExpiryData?.toDate && (
                <button
                  className="container-btn-file"
                  onClick={() => {
                    handleDownload(
                      stockExpiryData?.fromDate,
                      stockExpiryData?.toDate,
                      stockExpiryData?.market,
                      stockExpiryData?.agentName,
                      stockExpiryData?.productName,
                    );
                  }}
                  style={{
                    height: "38px",
                    marginLeft: "0",
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    fontSize: "14px",
                  }}
                >
                  <svg
                    fill="#fff"
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 50 50"
                  >
                    <path d="M28.8125 .03125L.8125 5.34375C.339844 5.433594 0 5.863281 0 6.34375L0 43.65625C0 44.136719 .339844 44.566406 .8125 44.65625L28.8125 49.96875C28.875 49.980469 28.9375 50 29 50C29.230469 50 29.445313 49.929688 29.625 49.78125C29.855469 49.589844 30 49.296875 30 49L30 1C30 .703125 29.855469 .410156 29.625 .21875C29.394531 .0273438 29.105469 -.0234375 28.8125 .03125ZM32 6L32 13L34 13L34 15L32 15L32 20L34 20L34 22L32 22L32 27L34 27L34 29L32 29L32 35L34 35L34 37L32 37L32 44L47 44C48.101563 44 49 43.101563 49 42L49 8C49 6.898438 48.101563 6 47 6ZM36 13L44 13L44 15L36 15ZM6.6875 15.6875L11.8125 15.6875L14.5 21.28125C14.710938 21.722656 14.898438 22.265625 15.0625 22.875L15.09375 22.875C15.199219 22.511719 15.402344 21.941406 15.6875 21.21875L18.65625 15.6875L23.34375 15.6875L17.75 24.9375L23.5 34.375L18.53125 34.375L15.28125 28.28125C15.160156 28.054688 15.035156 27.636719 14.90625 27.03125L14.875 27.03125C14.8125 27.316406 14.664063 27.761719 14.4375 28.34375L11.1875 34.375L6.1875 34.375L12.15625 25.03125ZM36 20L44 20L44 22L36 22ZM36 27L44 27L44 29L36 29ZM36 35L44 35L44 37L36 37Z" />
                  </svg>
                  Export File
                </button>
              )}
            </Stack>
          }
        />
        {/* taps */}
        <AppliedFilter
          onSave={(data) =>
            submitFilter({
              ...data,
              stockExpiryData,
            })
          }
          data={stockExpiryData}
          dispatch={dispatch}
          chipDisplay={["agentName","productName","market"]}
        />

        <ReusableFilter
          data={stockExpiryData}
          dispatch={dispatch}
          open={dialogOpen}
          onClose={() => setDialogOpen(false)}
          onSave={(data) =>
            submitFilter({
              ...data,
              stockExpiryData,
            })
          }
          title="Stock Expiry Filter"
        >
          <Grid size={{ xs: 12, sm: 6 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Agent Name
              </MaterialTypography>
            </MaterialBox>
            <Autocomplete
              multiple
              id="tags-outlined"
              options={agentOptions || []}
              getOptionLabel={(option) => option.label || ""}
              value={stockExpiryData?.agentName || []}
              onChange={(event, newValue) => {
                dispatch({ value: newValue, name: "agentName" });
              }}
              filterSelectedOptions
              renderTags={(selected, getTagProps) =>
                (selected || []).map((option, index) => (
                  <Chip
                    key={index}
                    label={option.label}
                    {...getTagProps({ index })}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField {...params} placeholder="Select Category(s)" />
              )}
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 6 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Product Name
              </MaterialTypography>
            </MaterialBox>
            <Autocomplete
              multiple
              id="tags-outlined"
              options={productOptions || []}
              getOptionLabel={(option) => option.label || ""}
              value={stockExpiryData?.productName || []}
              onChange={(event, newValue) => {
                dispatch({ value: newValue, name: "productName" });
              }}
              filterSelectedOptions
              renderOption={(props, option) => (
                <li {...props} key={option.id}>
                  {" "}
                  {option.label}
                </li>
              )}
              renderTags={(selected, getTagProps) =>
                (selected || []).map((option, index) => (
                  <Chip
                    key={index}
                    label={option.label}
                    {...getTagProps({ index })}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField {...params} placeholder="Select Product(s)" />
              )}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Market Name
              </MaterialTypography>
            </MaterialBox>
            <Autocomplete
              multiple
              id="tags-outlined"
              options={marketOptions || []}
              getOptionLabel={(option) => option.label || ""}
              value={stockExpiryData?.market || []}
              onChange={(event, newValue) => {
                dispatch({ value: newValue, name: "market" });
              }}
              filterSelectedOptions
              renderTags={(selected, getTagProps) =>
                (selected || []).map((option, index) => (
                  <Chip
                    key={index}
                    label={option.label}
                    {...getTagProps({ index })}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField {...params} placeholder="Select Market(s)" />
              )}
            />
          </Grid>
        </ReusableFilter>
        {!isLoading && isTabel && (
          <>
            {value === 0 ? (
              //Table list view
              <Box>
                {!isLoading && (
                  <MaterialDataGrid
                    rows={stockExpiryListTable?.rows}
                    columns={stockExpiryListTable?.columns}
                    isSelectable={false}
                    localeText={{
                      noRowsLabel: (
                        <Stack
                          direction="column"
                          alignItems="center"
                          justifyContent="center"
                          spacing={1}
                        >
                          <MaterialTypography
                            variant="body2"
                            fontWeight="medium"
                            color="text"
                          >
                            No results match your filters
                          </MaterialTypography>

                          <MaterialTypography variant="caption" color="text">
                            Try adjusting or clearing the filters to see Stock
                            Expiry data.
                          </MaterialTypography>
                        </Stack>
                      ),
                    }}
                  />
                )}
              </Box>
            ) : (
              //graph list view with pagination
              <Box>
                <ResponsiveContainer width="100%" height={450}>
                  <BarChart
                    data={currentData}
                    margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                    barSize={30}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis
                      dataKey="productName"
                      tick={{ fontSize: 12 }} // ⬅ smaller text
                      tickMargin={8}
                    />
                    <YAxis
                      tick={{ fontSize: 12 }} // ⬅ smaller text
                      tickMargin={8}
                    />
                    <Tooltip
                      contentStyle={{
                        fontSize: "12px",
                        borderRadius: "8px",
                        background: "rgba(255, 255, 255, 0.8)",
                        border: "1px solid #ccc",
                        padding: "2px",
                      }}
                      wrapperStyle={{ outline: "none" }}
                    />
                    <Legend wrapperStyle={{ fontSize: "12px" }} />
                    <Bar dataKey="quantity" fill="#8884d8" name="Quantity" />
                  </BarChart>
                </ResponsiveContainer>

                {/* Pagination Controls */}
                <Box display="flex" justifyContent="center" mt={2} mb={2}>
                  <IconButton
                    onClick={handlePrevious}
                    disabled={currentPage === 0}
                    aria-label="previous page"
                  >
                    <ArrowBackIosIcon />
                  </IconButton>
                  <Typography variant="body1" mx={2}>
                    Page {currentPage + 1} of {totalPages}
                  </Typography>
                  <IconButton
                    onClick={handleNext}
                    disabled={currentPage >= totalPages - 1}
                    aria-label="next page"
                  >
                    <ArrowForwardIosIcon />
                  </IconButton>
                </Box>
              </Box>
            )}
          </>
        )}

        {isLoading && <PageLoading />}
      </Card>
    </DashboardLayout>
  );
}

export default StockExpiry;
